import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { Loading } from '../../uiComponents/Loading';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Vejledning } from '../../models/Vejledning';
import VejledningAfsnitPresenter from './VejledningAfsnitPresenter';
import { RouteComponentProps } from 'react-router';
import { getVejledningTitle } from './VejledningTitle';

export interface VejledningPresenterProps extends RouteComponentProps<any> {
}

interface VejledningPresenterState {
    vejledning?: Vejledning;
}

export default class VejledningPresenter extends React.Component<VejledningPresenterProps, VejledningPresenterState> {
    constructor(props: VejledningPresenterProps) {
        super(props);
        this.state = {
            vejledning: undefined
        };
    }

    componentDidMount() {
        this.getVejledning(this.props.match.params.type);
    }

    getVejledning(type: string) {
        let self = this;
        let apicaller = createApiCaller();
        apicaller.getVejledning(type)
            .then((response) => {
                self.setState({ vejledning: response });
            });
    }

    componentWillReceiveProps(newProps: VejledningPresenterProps) {
        this.getVejledning(newProps.match.params.type);
    }

    getAfsnit() {
        if (this.state.vejledning !== undefined) {
            return this.state.vejledning.afsnit.map((a, i) => {
                if (a.overskrift !== undefined && a.overskrift.length > 0) {
                    return <VejledningAfsnitPresenter afsnit={a} key={i} index={i} />;
                }

                return undefined;
            });
        }

        return undefined;
    }

    scrollToSection = (id: string) => {
        let $element = $('#' + id);
        let offset = $element.offset();
        if (offset !== undefined) {
            $('html, body').animate({
                scrollTop: offset.top
            },                      1000);
        }
    }

    getIndholdsfortegnelse = () => {
        if (this.state.vejledning !== undefined) {
            return this.state.vejledning.afsnit.map((a, i) => {
                if (a.overskrift !== undefined && a.overskrift.length > 0) {
                    return <li key={i} onClick={x => this.scrollToSection('afsnit_' + i)}><a>{a.overskrift}</a></li>;
                }

                return undefined;
            });
        }

        return undefined;
    }   

    render() {
        return (
            <PageWrapper className='laerervejledning-presenter'>
                <PageTitle title={getVejledningTitle(this.props.match.params.type)} />
                <Loading isLoading={this.state.vejledning === undefined}>
                    <ContentWrapper>
                        <h1>Indholdsfortegnelse</h1>
                        <ul className='indholdsfortegnelse'>
                            {this.getIndholdsfortegnelse()}
                        </ul>
                        {this.getAfsnit()}
                    </ContentWrapper>
                </Loading>
            </PageWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Vejledning/VejledningPresenter.tsx